import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from '../../components/Header';
import Nav from '../../components/Nav';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { endpointApi } from '../../utils';
import axios from 'axios';
import { getUsers } from '../../redux/actions/user.action';
import { setLoading } from '../../redux/actions/loader.action';
import { logout } from '../../redux/actions/auth.action';
import Paginate from '../../components/Paginate';

export default function UsersPage() {
    const jwt_access = localStorage.getItem('jwt_access');
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const users = useSelector(state => state.users);
    const { me } = useSelector(state => state.auth);
    
    // variables
    const modalRef = useRef(null);
    const detailsModalRef = useRef(null);
    const [user, setUser] = useState(null);
    const [add, setAdd] = useState(true);
    const [modal, setModal] = useState(null);
    const [actionModal, setActionModal] = useState(null);

    const [gender, setGender] = useState("");
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [phone, setPhone] = useState("");
    const [job, setJob] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [role, setRole] = useState("");
    const [status, setStatus] = useState("");
    const [isGenderTouched, setIsGenderTouched] = useState(false);
    const [isFirstnameTouched, setIsFirstnameTouched] = useState(false);
    const [isLastnameTouched, setIsLastnameTouched] = useState(false);
    const [isPhoneTouched, setIsPhoneTouched] = useState(false);
    const [isJobTouched, setIsJobTouched] = useState(false);
    const [isEmailTouched, setIsEmailTouched] = useState(false);
    const [isPasswordTouched, setIsPasswordTouched] = useState(false);
    const [isRoleTouched, setIsRoleTouched] = useState(false);
    const [isStatusTouched, setIsStatusTouched] = useState(false);
    const [errors, setErrors] = useState(null);

    useEffect(() => {
        dispatch(getUsers(location, navigate));
    }, [location, dispatch, navigate]);

    const _close = useCallback(() => {
        setModal(null);
        setGender("");
        setFirstname("");
        setLastname("");
        setPhone("");
        setJob("");
        setEmail("");
        setPassword("");
        setRole("");
        setStatus("");
        setIsGenderTouched(false);
        setIsFirstnameTouched(false)
        setIsLastnameTouched(false);
        setIsPhoneTouched(false);
        setIsJobTouched(false);
        setIsEmailTouched(false);
        setIsPasswordTouched(false);
        setIsRoleTouched(false);
        setIsStatusTouched(false);
        dispatch(setLoading(false));
        setErrors(null);

        setTimeout(() => {
            setAdd(true);
            setUser(null);
        }, 200);
    }, [dispatch]);

    const close = useCallback((e) => {
        if((modalRef.current && modalRef.current === e.target && modalRef.current.classList.contains('active')) || (detailsModalRef.current && detailsModalRef.current === e.target && detailsModalRef.current.classList.contains('active')) || e.target.classList.contains('_modal-close')){
            _close();
        }
    }, [_close]);

    useEffect(() => {
        const clickOutsideActionModal = (e) => {
            const $actionModals = document.querySelectorAll('.actions>ul');
            $actionModals.forEach($actionModal => {
                if($actionModal && !$actionModal.contains(e.target) && $actionModal.classList.contains('active')){
                setActionModal(null);
                }
            });
        }
        document.addEventListener('click', clickOutsideActionModal);
        return () => {
            document.removeEventListener('click', clickOutsideActionModal);
        }
    }, []);

    useEffect(() => {
        document.addEventListener('click', close);
        return () => {
            document.removeEventListener('click', close);
        }
    }, [close]);

    useEffect(() => {
        if(user && modal === "update"){
            setGender(user.gender ? user.gender : "");
            setFirstname(user.first_name ? user.first_name : "");
            setLastname(user.last_name ? user.last_name : "");
            setPhone(user.phone ? user.phone : "");
            setJob(user.job ? user.job : "");
            setEmail(user.email ? user.email : "");
            setPassword("");
            setRole(user.role ? user.role : "");
            setStatus(user.status ? user.status : "");
            setAdd(false);
        }
    }, [user, modal]);

    useEffect(() => {
        if(modal){
            const $modals = document.querySelectorAll('._modal-content');
            $modals.forEach($modal => {
                $modal.scrollTop = 0;
            });
        }
    }, [modal]);

    const handleSubmit = async(e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);
        if(add){
            await axios.post(`${ endpointApi }users`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${ jwt_access }`
                }
            }).then(({ data }) => {
                dispatch(getUsers(location, navigate));
                setUser(data);
                setModal('details');
            }).catch(err => {
                if(err.response.status === 401){
                    dispatch(logout(location.pathname + location.search, navigate));
                }else{
                    setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                    const $modals = document.querySelectorAll('._modal-content');
                    $modals.forEach($modal => {
                        $modal.scrollTop = 0;
                    });
                }
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
        }else{
            await axios.put(`${ endpointApi }users/${ user.id }`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${ jwt_access }`
                }
            }).then(({ data }) => {
                dispatch(getUsers(location, navigate));
                setUser(data);
                setModal('details');
            }).catch(err => {
                if(err.response.status === 401){
                    dispatch(logout(location.pathname + location.search, navigate));
                }else{
                    setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                    const $modals = document.querySelectorAll('._modal-content');
                    $modals.forEach($modal => {
                        $modal.scrollTop = 0;
                    });
                }
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
        }
    }

    useEffect(() => {
        if(!jwt_access){
            navigate('/login?redirect_to=' + location.pathname + location.search);
        }
    }, [location, navigate, jwt_access]);

    return (
        me &&
        <HelmetProvider>
            <Helmet>
                <title>Utilisateurs - Société Mikalo</title>
            </Helmet>

            <Header />

            <Nav />

            <main id='main'>
                <div className='title d-flex justify-content-between'>
                    <h1>Utilisateurs</h1>
                    <button type='button' onClick={ () => {
                        setAdd(true);
                        setModal('add');
                    } } className='btn btn-primary'><i className='fa fa-plus'></i> Ajouter</button>
                </div>

                <div ref={ modalRef } className={ `_modal${ modal === 'add' || (modal === 'update' && user) ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            <h4>{ add ? 'Ajouter' : 'Modifier' } un utilisateur</h4>
                            <button className='_modal-close'>&times;</button>
                        </div>
                        <div className='_modal-body'>
                            <form className='form' onSubmit={ handleSubmit }>
                                { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                                <div className='pb-3'>
                                    <label htmlFor='gender' className='required'>Civilité</label>
                                    <select id='gender' name='gender' className='form-control' required value={ gender } onChange={ (e) => setGender(e.target.value) } onBlur={ () => setIsGenderTouched(true) }>
                                        <option value="">Sélectionner...</option>
                                        <option value="m">Monsieur</option>
                                        <option value="f">Madame</option>
                                    </select>
                                    { isGenderTouched && gender.length === 0 && <div className='form-error'>Veuillez sélectionner la civilité.</div> }
                                    { errors && errors.gender && <div className='form-error'>{ errors.gender[0] }</div> }
                                </div>
                                <div className='row'>
                                    <div className='col-6 pb-3'>
                                        <label htmlFor='last_name' className='required'>Nom</label>
                                        <input type='text' id='last_name' name='last_name' placeholder='Nom' autoComplete='off' className='form-control' required value={ lastname } onChange={ (e) => setLastname(e.target.value) } onBlur={ () => setIsLastnameTouched(true) } />
                                        { isLastnameTouched && lastname.length === 0 && <div className='form-error'>Veuillez saisir le nom.</div> }
                                        { errors && errors.last_name && <div className='form-error'>{ errors.last_name[0] }</div> }
                                    </div>
                                    <div className='col-6 pb-3'>
                                        <label htmlFor='first_name' className='required'>Prénom(s)</label>
                                        <input type='text' id='first_name' name='first_name' placeholder='Prénom(s)' autoComplete='off' className='form-control' required value={ firstname } onChange={ (e) => setFirstname(e.target.value) } onBlur={ () => setIsFirstnameTouched(true) } />
                                        { isFirstnameTouched && firstname.length === 0 && <div className='form-error'>Veuillez saisir le prénom.</div> }
                                        { errors && errors.first_name && <div className='form-error'>{ errors.first_name[0] }</div> }
                                    </div>
                                </div>
                                <div className='pb-3'>
                                    <label htmlFor='job' className='required'>Fonction</label>
                                    <input type='text' id='job' name='job' placeholder='Fonction' autoComplete='off' className='form-control' required value={ job } onChange={ (e) => setJob(e.target.value) } onBlur={ () => setIsJobTouched(true) } />
                                    { isJobTouched && job.length > 0 && job.length < 2 && <div className='form-erorr'>La valeur de ce champ est trop courte. Veuillez saisir au moins 2 caractères.</div> }
                                    { errors && errors.job && <div className='form-error'>{ errors.job[0] }</div> }
                                </div>
                                <div className='pb-3'>
                                    <label htmlFor='phone'>Téléphone</label>
                                    <input type='text' id='phone' name='phone' placeholder='Téléphone' autoComplete='off' className='form-control' value={ phone } onChange={ (e) => setPhone(e.target.value) } onBlur={ () => setIsPhoneTouched(true) } />
                                    { isPhoneTouched && phone.length > 0 && /^(\+261|0)3[23478]\s?\d{2}\s?\d{3}\s?\d{2}$/.test(phone) === false && <div className='form-erorr'>Le numéro de téléphone n'est pas valide.</div> }
                                    { errors && errors.phone && <div className='form-error'>{ errors.phone[0] }</div> }
                                </div>
                                <div className='pb-3'>
                                    <label htmlFor='email' className='required'>E-mail</label>
                                    <input type='email' id='email' name='email' placeholder='E-mail' autoComplete='off' className='form-control' required value={ email } onChange={ (e) => setEmail(e.target.value) } onBlur={ () => setIsEmailTouched(true) } />
                                    { isEmailTouched && email.length === 0 && <div className='form-error'>Veuillez saisir l'e-mail.</div> }
                                    { isEmailTouched && email.length > 0 && /^[a-z0-9.-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(email) === false && <div className='form-error'>L'e-mail n'est pas valide. Veuillez vérifier.</div> }
                                    { errors && errors.email && <div className='form-error'>{ errors.email[0] }</div> }
                                </div>
                                <div className='pb-3'>
                                    <label htmlFor='password' className={ add ? 'required' : '' }>Mot de passe{ add === false && <> (Laisser vide pour garder l'actuel)</> }</label>
                                    <input type='password' id='password' name='password' placeholder='Mot de passe' className='form-control' required={ add } value={ password } onChange={ (e) => setPassword(e.target.value) } onBlur={ () => setIsPasswordTouched(true) } />
                                    { add && isPasswordTouched && password.length === 0 && <div className='form-error'>Veuillez saisir le mot de passe.</div> }
                                    { isPasswordTouched && password.length > 0 && password.length < 8 && <div className='form-error'>Le mot de passe est trop court. Veuilliez saisir au moins 8 caractères.</div> }
                                    { errors && errors.password && <div className='form-error'>{ errors.password[0] }</div> }
                                </div>
                                <div className='pb-3'>
                                    <label htmlFor='role' className='required'>Rôle</label>
                                    <select id='role' name='role' className='form-control' required value={ role } onChange={ (e) => setRole(e.target.value) } onBlur={ () => setIsRoleTouched(true) }>
                                        <option value="">Sélectionner...</option>
                                        <option value="admin">Administrateur</option>
                                        <option value="superadmin">Super administrateur</option>
                                    </select>
                                    { isRoleTouched && role.length === 0 && <div className='form-error'>Veuillez sélectionner le rôle.</div> }
                                    { errors && errors.role && <div className='form-error'>{ errors.role[0] }</div> }
                                </div>
                                <div className='pb-3'>
                                    <label htmlFor='status' className='required'>Statut</label>
                                    <select id='status' name='status' className='form-control' required value={ status } onChange={ (e) => setStatus(e.target.value) } onBlur={ () => setIsStatusTouched(true) }>
                                        <option value="">Sélectionner...</option>
                                        <option value="0">En attente</option>
                                        <option value="1">Activé</option>
                                        <option value="2">Bloqué</option>
                                    </select>
                                    { isStatusTouched && status.length === 0 && <div className='form-error'>Veuillez sélectionner le statut.</div> }
                                    { errors && errors.status && <div className='form-error'>{ errors.status[0] }</div> }
                                </div>
                                <div className='pt-2 text-end'>
                                    <button type='submit' className='btn btn-lg btn-primary' disabled={
                                        gender.length === 0 || firstname.length === 0 || lastname.length === 0 || (job.length > 0 && job.length < 2) || (phone.length > 0 && /^(\+261|0)3[23478]\s?\d{2}\s?\d{3}\s?\d{2}$/.test(phone) === false) || /^[a-z0-9.-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(email) === false || (password.length > 0 && password.length < 8) || (add === true && password.length < 8) || role.length === 0 || status.length === 0 ||
                                        (user && add === false && gender === user.gender && lastname === user.last_name && firstname === user.first_name && job === user.job && phone === user.phone && email === user.email && password === '' && role === user.role && status === user.status)
                                    }>{ add ? <><i className="fa fa-save"></i> Enregistrer</> : <><i className="fa fa-save"></i> Mettre à jour</> }</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div ref={ detailsModalRef } className={ `_modal${ modal === 'details' && user ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            { user &&
                            <h4>{ user.last_name + " " + user.first_name }</h4> }
                            <button type='button' className='_modal-close'>&times;</button>
                        </div>
                        <div className='_modal-body'>
                        { user && <>
                            <div className='mb-3'>
                                <div className='_label'>ID</div>
                                <div className='_value'>#{ user.id }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Civilité</div>
                                <div className='_value'>{ user.gender === 'm' ? 'Monsieur' : 'Madame' }</div>
                            </div>
                            <div className='row'>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>NOM</div>
                                    <div className='_value'>{ user.last_name }</div>
                                </div>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Prénom(s)</div>
                                    <div className='_value'>{ user.first_name }</div>
                                </div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Fonction</div>
                                <div className='_value'>{ user.job }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Téléphone</div>
                                <div className='_value'>{ user.phone }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>E-mail</div>
                                <div className='_value'>{ user.email }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Rôle</div>
                                <div className='_value'><i className='fa fa-lock' style={{ color: "var(--bs-success)"}}></i> { user.role === 'superadmin' ? 'Super administrateur' : 'Administrateur' }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Etat</div>
                                <div className='_value'>{ user.status === 0 ? <span className='badge bg-warning'>En attente</span> : (user.status === 1 ? <span className='badge bg-success'>Activé</span> : <span className='badge bg-danger'>Bloqué</span>) }</div>
                            </div>
                            <div className='text-end pt-2'>
                                <button className='btn btn-lg btn-primary' onClick={ () => setModal("update") }><i className="fa fa-edit"></i> Modifier</button>
                            </div>
                        </> }
                        </div>
                    </div>
                </div>

                <div className='box'>
                    <table className='table table-striped'>
                        <thead>
                            <tr>
                                <th width="100">#ID</th>
                                <th>Nom et prénom</th>
                                <th>E-mail</th>
                                <th>Téléphone</th>
                                <th>Rôle</th>
                                <th>Statut</th>
                                <th width="75" className="text-end">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                        { users.loading && <tr><td colSpan={ 7 }>Chargement...</td></tr> }
                        { users.loading === false && users.data && users.data.total === 0 && <tr><td colSpan={ 7 }>Aucun élément trouvé</td></tr> }
                        { users.loading === false && users.data && users.data.data && users.data.data.map((item, index) => {
                            return (
                            <tr key={ index }>
                                <td>#{ item.id }</td>
                                <td>{ item.last_name } { item.first_name }</td>
                                <td>{ item.email }</td>
                                <td>{ item.phone }</td>
                                <td><i className='fa fa-lock' style={{ color: "var(--bs-success)"}}></i> { item.role === 'superadmin' ? 'Super administrateur' : 'Administrateur' }</td>
                                <td>{ item.status === 0 ? <span className='badge bg-warning'>En attente</span> : (item.status === 1 ? <span className='badge bg-success'>Activé</span> : <span className='badge bg-danger'>Bloqué</span>) }</td>
                                <td className="text-end">
                                    <div className='actions'>
                                        <button type='button' className='toggle-action' onClick={ (e) => {
                                            e.stopPropagation();
                                            setActionModal(actionModal !== item.id ? item.id : null);
                                        } }><i className='fa fa-ellipsis-v'></i></button>
                                        <ul className={ actionModal === item.id ? 'active' : '' }>
                                            <li><button type='button' onClick={ () => {
                                                setActionModal(null);
                                                setUser(item);
                                                setModal("details");
                                            } }><i className="fa fa-eye"></i> Voir les détails</button></li>
                                            <li><button type='button' onClick={ () => {
                                                setActionModal(null);
                                                setModal("update");
                                                setUser(item);
                                            } }><i className="fa fa-edit"></i> Modifier</button></li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        ) })}
                        </tbody>
                    </table>
                </div>
                
                { users && users.data &&
                <Paginate currentPage={ users.data.current_page } totalPages={ users.data.last_page } pathname={ location.pathname } search={ location.search } /> }
            </main>
        </HelmetProvider>
    )
}
